import { container } from "tsyringe";
import classes from "./classes.module.scss";
import MediaService from "services/projects/MediaService";
import MediaResponseResource from "common/resources/Project/Config/Media/MediaResponseResource";
import { useEffect, useState } from "react";
import { useProjectId } from "hooks/useProjectId";
import MediaCard from "components/pages/ProfessionalSpace/tabs/Media/MediaContainer/MediaCard";
import MediaModal from "components/pages/ProfessionalSpace/tabs/Media/MediaContainer/MediaModal";

const mediaService = container.resolve(MediaService);

type IProps = {};

export default function Medias(_props: IProps) {
	const { projectId } = useProjectId();
	const { medias } = useMedias(projectId);
	const [mediaOpen, setMediaOpen] = useState<MediaResponseResource | null>(null);

	return (
		<div className={classes["root"]}>
			{medias.map((media) => (
				<MediaCard key={media.id} media={media} onOpen={setMediaOpen} />
			))}
			{mediaOpen && <MediaModal media={mediaOpen} isOpen={!!mediaOpen} onClose={() => setMediaOpen(null)} />}
		</div>
	);
}

const useMedias = (projectId: string) => {
	const [medias, setMedias] = useState<MediaResponseResource[]>([]);

	useEffect(() => {
		mediaService.getByProjectId(projectId).then(setMedias);
	}, [projectId]);

	return { medias };
};
